<template>
  <div>
    <b-card
      v-for="request in requests"
      class="mb-3"
      :key="request.id"
      :title="request.course"
      :sub-title="`${request.id}: ${request.developer_lastname}`"
    >
      <ul>
        <li v-for="(value, name, index) in request" :key="index">
          <em> {{ name }}: </em>{{ value }}
        </li>
      </ul>
      <GAssignLeadsForm :project="request" />
    </b-card>
  </div>
</template>

<script>
  import GAssignLeadsForm from '@/components/GAssignLeadsForm.vue'

  export default {
    name: 'GOfditApproval',
    components: {
      GAssignLeadsForm
    },
    data() {
      return {}
    },
    created() {
      this.$store.dispatch('getProjects')
      this.$store.dispatch('getUserList')
    },
    computed: {
      requests() {
        return this.$store.getters.dataImportedProjects
      }
    },
    methods: {}
  }
</script>

<style scoped></style>
